function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "tlmkzduepa",
  d: "M6.902 2.53h2.196c.384 0 .695-.302.695-.675 0-.372-.311-.674-.695-.674H6.902c-.384 0-.695.302-.695.674 0 .373.311.675.695.675zm-5.51 10.12h13.217V6.579H1.39v6.073zM16 1.919v11.407c0 .373-.311.675-.696.675H.696C.31 14 0 13.698 0 13.325V1.918c0-.373.311-.737.696-.737h1.626c.384 0 .695.302.695.674 0 .373-.311.675-.695.675h-.93v2.868h13.217V2.53h-.93c-.385 0-.696-.302-.696-.675 0-.372.311-.674.695-.674h1.626c.385 0 .696.364.696.737zm-4.696 1.929c.48 0 .87-.378.87-.844V.843c0-.465-.39-.843-.87-.843s-.87.378-.87.843v2.16c0 .466.39.844.87.844zM6.081 8.729c.097 0 .175.077.175.171v1.862c0 .095-.078.171-.175.171H4.175c-.097 0-.175-.076-.175-.17V8.9c0-.094.078-.171.175-.171zm3.067 0c.097 0 .175.077.175.171v1.862c0 .095-.078.171-.175.171H7.242c-.097 0-.175-.076-.175-.17V8.9c0-.094.078-.171.175-.171zm3.067 0c.097 0 .175.077.175.171v1.862c0 .095-.078.171-.175.171h-1.906c-.097 0-.175-.076-.175-.17V8.9c0-.094.078-.171.175-.171zM4.695 0c.48 0 .87.378.87.843v2.16c0 .466-.39.844-.87.844s-.869-.378-.869-.844V.843c0-.465.39-.843.87-.843z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-489 -212) translate(224 208) translate(265 4) translate(4 5)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "0ba2w7p9kb",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#tlmkzduepa"
})), /*#__PURE__*/React.createElement("use", {
  fill: "currentColor",
  xlinkHref: "#tlmkzduepa"
}), /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  mask: "url(#0ba2w7p9kb)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0H24V24H0z",
  transform: "translate(-4 -5)"
})))))));

function SvgIconCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendar);
export default __webpack_public_path__ + "static/media/icon-calendar.9ca012ce.svg";
export { ForwardRef as ReactComponent };